import { PageDefault } from './../PageDefault';
import { Component, OnInit } from '@angular/core';
import { NavController, ModalController, NavParams } from 'ionic-angular';
import { DailyWageSetService } from './../../services/dailywageset.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
// import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { AppConfig } from './../../app/app.config';
import { SetDailyWagesPage } from './setdailywages';
import { DailyWagesModel, DailyWagesRulesModel } from './../../models/dailywageset.model';

import { List } from 'linqts';
import * as $ from 'jquery';
import { FixedExtend } from './../../config/fixed-extend';

@Component({
  selector: 'page-dailywageset',
  templateUrl: 'dailywageset.html',
  providers: [
    DailyWageSetService,
    FixedExtend
  ]
})
export class DailywagesetPage {
  constructor(
    private dailywageset: DailyWageSetService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private modalCtrl: ModalController,
    private navpar: NavParams,
    private config: AppConfig,
    public navCtrl: NavController,
    private alert: AlertService,
    private indexExtend: FixedExtend
  ) { }

  modelList: DailyWagesModel[] = [];
  // searchUser: string;

  getDailywageInput = {
    subUserName: '',
    pageIndex: 1,
    pageSize: PageDefault.PageSize(),
  };
  hasmore = false;
  isHave = true;

  ionViewDidEnter() {
    this.getDailywageSet();
  }
  //设置日工资比例
  dailywages(userName) {
    this.navCtrl.push(SetDailyWagesPage, { userName: userName });
  }


  // 获取日工资设置列表
  getDailywageSet() {
    let load = this.loadding.showLoding();
    return this.dailywageset.getDirectSubUser(this.getDailywageInput).then(s => {
      this.loadding.closeLoading(load);
      if (this.getDailywageInput.pageIndex == 1) {
        this.modelList = [];
        this.modelList = s.List;
        if (s.List.length < s.PageCount) {
          this.hasmore = true;
        } else {
          this.hasmore = false;
        }
      } else {
        this.modelList = this.modelList.concat(s.List);
        if (this.modelList.length < s.PageCount) {
          this.hasmore = true;
        }
        else {
          this.getDailywageInput.pageIndex = 1;
          this.hasmore = false;
        }
      }
      if (this.modelList.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
    }).catch(() => {
      this.loadding.closeLoading(load);
    });
  }

  //下拉重新加载
  //TQQ 2018-06-12
  doRefresh(refresher) {
    this.getDailywageInput.pageIndex = 1;
    this.getDailywageSet().then(() => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2018-06-12
  doInfinite(infiniteScroll) {
    this.getDailywageInput.pageIndex++;
    this.getDailywageSet().then(() => {
      infiniteScroll.complete();
    });
  }

}




// WEBPACK FOOTER //
// ./src/pages/dailywageset/dailywageset.ts